module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-screen"
  }, [_c('div', {
    staticClass: "intro-text-container"
  }, [_c('div', {
    staticClass: "intro-text-box"
  }, [_c('div', {
    staticClass: "introtext title-02",
    domProps: {
      "innerHTML": _vm._s(_vm.episode.introtext)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/vraag"
    }
  }, [_vm._v("OK")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-679d84ab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/InfoScreen.vue
// module id = 120
// module chunks = 1